import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import defaultTexts from '../../../texts/texts'
import { setProgressStep, setGroup } from '../../../store/reducers/subscriptionAddSlice'
import parse from 'html-react-parser'

const SelectProductWrapper = (props) => {
  const { setStep, subscriptionGroupsData, subscriptionGroupNames, selectedProduct, setSelectedProduct } = props
  const theme = useTheme()
  const dispatch = useDispatch()

  const [filteredSubscriptionGroupsData, setFilteredSubscriptionGroupsData] = useState([])

  const wrapperStyle = {
    minHeight: '400px',
    padding: '20px',
    background: theme.palette.oxfordBlue,
    borderRadius: '20px',
    margin: '40px 0px 20px 0px',
    cursor: 'pointer',
  }

  const checkboxStyle = {
    width: '24px',
    height: '24px',
    borderRadius: '8px',
    background: 'white',
    color: theme.palette.oxfordBlue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }

  const labelStyle = {
    fontSize: '24px',
    color: theme.palette.violetsAreBlue,
    paddingBottom: '20px',
  }

  const descriptionStyle = {
    fontSize: '18px',
    color: 'white',
  }

  const nextButtonStyle = {
    fontWeight: '400',
    color: 'white',
    background: theme.palette.violetsAreBlue,
    fontSize: '18px',
    height: '44px',
    borderRadius: '22px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.violetsAreBlue, 0.8),
    },

    '&:disabled': {
      background: theme.palette.grayX11,
      color: 'white',
    },
  }

  const handleSelectProduct = (product) => {
    setSelectedProduct(prev => prev === product ? null : product)
  }

  const handleClickNext = () => {
    setStep(2)
    dispatch(setProgressStep({ progress_step: 2 }))
    dispatch(setGroup({ group: selectedProduct }))
  }

  useEffect(() => {
    setFilteredSubscriptionGroupsData(subscriptionGroupsData.filter(item => !subscriptionGroupNames.includes(item.group_name)))
  }, [subscriptionGroupsData, subscriptionGroupNames])
  
  return (
    <>
      <Grid container spacing={4}>
        {
          filteredSubscriptionGroupsData.map((item, index) => (
            <Grid key={index} size={{ xs: 12, md: 6, xl: 4 }}>
              <Box sx={wrapperStyle} onClick={() => handleSelectProduct(item.group_name)}>
                <Stack
                  direction='row'
                  alignItems='flex-start'
                  justifyContent='flex-start'
                  spacing={4}
                >
                  <Box sx={checkboxStyle}>
                    { selectedProduct === item.group_name && <CheckIcon /> }
                  </Box>
                  <Box sx={{ width: 'calc(100% - 60px)' }}>
                    <Box sx={labelStyle}>{item.title.value}</Box>
                    <Box sx={descriptionStyle}>
                      {
                        item.promo_texts.map((item2, index2) => (
                          <Box key={index2} sx={{ paddingBottom: '20px' }}>{parse(item2)}</Box>
                        ))
                      }
                    </Box>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          ))
        }
      </Grid>

      <Stack
        direction='row'
        justifyContent='flex-end'
      >
        <Button
          variant='text'
          disableRipple
          disableElevation
          disabled={selectedProduct ? false : true}
          sx={nextButtonStyle}
          onClick={handleClickNext}
        >
          {defaultTexts.next}
        </Button>
      </Stack>
    </>
  )
}

export default SelectProductWrapper